import PropTypes from 'prop-types';

export const GatsbyImagePropType = PropTypes.shape({
  altText: PropTypes.string,
  fixed: PropTypes.shape({
    base64: PropTypes.string,
    width: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    height: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    src: PropTypes.string,
    srcSet: PropTypes.string,
  }),
  fluid: PropTypes.shape({
    base64: PropTypes.string,
    width: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    height: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    src: PropTypes.string,
    srcSet: PropTypes.string,
  }),
});

export const BlogPostPropType = PropTypes.shape({
  id: PropTypes.number.isRequired,
  title: PropTypes.string.isRequired,
  author: PropTypes.string,
  slug: PropTypes.string.isRequired,
  summary: PropTypes.string,
  publishedAt: PropTypes.string,
  heroImage: PropTypes.oneOfType([PropTypes.string, GatsbyImagePropType]),
});

export const TextAlignPropType = PropTypes.oneOf(['left', 'center', 'right', 'justified']);
export const VerticalAlignPropType = PropTypes.oneOf(['bottom', 'middle', 'top']);
export const ChildrenPropType = PropTypes.oneOfType([
  PropTypes.node,
  PropTypes.element,
  PropTypes.arrayOf(PropTypes.node),
  PropTypes.arrayOf(PropTypes.element),
]);

export const SiteNavigationLinkPropType = PropTypes.shape({
  title: PropTypes.string.isRequired,
  pageType: PropTypes.string.isRequired,
  slug: PropTypes.string,
  url: PropTypes.string,
  groupName: PropTypes.string,
  navigationPriority: PropTypes.number,
  as: PropTypes.string,
});

export const AsPropType = PropTypes.oneOfType([
  PropTypes.string,
  PropTypes.elementType,
]);
